module.exports = __webpack_public_path__ + "media/bootstrap-icons/palette2-adb25be2.svg";